const dumps = (data, indent) => JSON.stringify(data, null, indent)
const loads = data => (data ? JSON.parse(data) : null)

export default { loads, dumps }
